shadow$provide[110] = function(require,module,exports) {
module.exports=(React);
};